import { computed, type WritableComputedRef } from 'vue';

/** kW → MW: stored in kW, displayed in MW */
export const KW_TO_MW = 0.001;
/** t/kW → t/MW: stored in t/kW, displayed in t/MW */
export const PER_KW_TO_PER_MW = 1000;
export function useUnitConversion(
    getter: () => number | null,
    setter: (val: number | null) => void,
    factor: number,
): WritableComputedRef<number | null> {
    return computed({
        get: () => {
            const val = getter();
            return val != null ? val * factor : null;
        },
        set: (val: number | null) => {
            setter(val != null ? val / factor : null);
        },
    });
}
